import type { Reducer } from 'redux';
import type { DealSpdActions } from '../actionTypes/complianceActionTypes';
import { DEAL_SPD_FAILURE, DEAL_SPD_REQUEST, DEAL_SPD_SUCCESS } from '../actionTypes/complianceActionTypes';

type DealSPDState = {
    data: any;
    isLoading: boolean;
    error: any;
};

export const DealSPDInitialState: DealSPDState = {
    data: null,
    isLoading: false,
    error: null
};

export type DealSpdReducer = Reducer<DealSPDState>;

export const reducer: Reducer<DealSPDState> = (state = DealSPDInitialState, action: DealSpdActions) => {
    switch (action.type) {
        case DEAL_SPD_REQUEST:
            return { ...state, isLoading: true, error: null };
        case DEAL_SPD_SUCCESS:
            return { ...state, isLoading: false, data: action.payload, error: null };
        case DEAL_SPD_FAILURE:
            return { ...state, isLoading: false, error: action.payload };
        default:
            return state;
    }
};
